import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Content = styled.div`
	padding: 20px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const QuestImage = styled.div<{ $src?: string }>`
	width: 120px;
	height: 120px;
	background-image: url('${({ $src }) => $src}');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	border-radius: 12px;
`;

export const RewardSection = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 20px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.title};

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.colors.icon.main};
	}
`;

export const Description = styled.div`
	font-size: 14px;
	line-height: 1.5;
	color: ${({ theme }) => theme.colors.text.body};
	max-height: min(340px, 15vh);
	overflow: auto;

	a {
		color: ${({ theme }) => theme.colors.text.body};
		text-decoration: underline;
	}

	p {
		margin: 0 0 12px 0;

		&:last-child {
			margin-bottom: 0;
		}
	}

	ul,
	ol {
		margin: 0 0 12px 0;
		padding-left: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	li {
		margin-bottom: 4px;

		&:last-child {
			margin-bottom: 0;
		}
	}
`;

export const Footer = styled.div`
	display: flex;
	gap: 12px;
	padding: 0 24px 24px;
	justify-content: flex-end;

	@media (max-width: 768px) {
		flex-direction: column;
	}
`;
